import src from "IMAGE";
export default { src, width: 1089, height: 174, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mOILc7JMY/yNlc1cXRUNXDwVtGzdwRiFyD2UNa1dwcAjWAHzdsxHj4AAAAASUVORK5CYII="};
